module.exports = __webpack_public_path__ + "img/Moonbase_Managing.69bb7663.png";